// extracted by mini-css-extract-plugin
export default {"heroCont":"Hero_heroCont__ypxlk","hero":"Hero_hero__jj8Sm","leftHero":"Hero_leftHero__35Q6H","btnDiv":"Hero_btnDiv__69usc","rightHero":"Hero_rightHero__ypeAm"};